module.exports = __webpack_public_path__ + "static/img/icon_drawer.2fecca06.png";